import {ChangeDetectionStrategy, Component, ElementRef, Input, OnInit} from '@angular/core';
import {WalkThroughStep, WalkThroughTooltipPosition} from '../../../types/walkthough.type';
import {WalkTroughService} from '../walkthough.service';

interface TooltipPosition {
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
}

@Component({
  selector: 'mc-walkthrough-tooltip',
  templateUrl: './walkthrough-tooltip.component.html',
  styleUrls: ['./walkthrough-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalkThroughTooltipComponent implements OnInit {
  @Input() text: string;
  @Input() rect: DOMRect;
  @Input() position: WalkThroughTooltipPosition;

  public progress: number;
  public tooltipPosition: TooltipPosition;
  public currentStep: WalkThroughStep;
  public currentStepNumber: number;
  public stepsCount: number;

  constructor(
    private ref: ElementRef,
    private walkTroughService: WalkTroughService,
  ) {}

  get lastStep() {
    return this.currentStepNumber === this.stepsCount;
  }

  ngOnInit(): void {
    this.ref.nativeElement.focus();
    this.tooltipPosition = this.calcPosition();
    this.currentStep = this.walkTroughService.activeStep;
    this.currentStepNumber = this.walkTroughService.currentStepIndex + 1;
    this.stepsCount = this.walkTroughService.stepsCount;
    this.progress = (this.currentStepNumber * 100) / this.stepsCount;
  }

  calcPosition(): TooltipPosition {
    const INDENT = 20;
    const position: TooltipPosition = {};

    switch (this.position) {
      case WalkThroughTooltipPosition.BottomLeft:
      case WalkThroughTooltipPosition.BottomRight:
      case WalkThroughTooltipPosition.BottomMiddle:
        position.top = `${this.rect.bottom + INDENT}px`;
        break;
      case WalkThroughTooltipPosition.TopLeft:
      case WalkThroughTooltipPosition.TopRight:
      case WalkThroughTooltipPosition.TopMiddle:
        position.top = `${this.rect.top - INDENT}px`;
        break;
      case WalkThroughTooltipPosition.RightBottom:
        position.left = `${this.rect.right + INDENT}px`;
        break;
      case WalkThroughTooltipPosition.LeftBottom:
        position.left = `${this.rect.left - INDENT}px`;
        break;
    }

    switch (this.position) {
      case WalkThroughTooltipPosition.TopMiddle:
      case WalkThroughTooltipPosition.BottomMiddle:
      case WalkThroughTooltipPosition.TopRight:
      case WalkThroughTooltipPosition.BottomRight:
      case WalkThroughTooltipPosition.TopLeft:
      case WalkThroughTooltipPosition.BottomLeft:
        position.left = `${this.rect.left + this.rect.width / 2}px`;
        break;
      case WalkThroughTooltipPosition.RightBottom:
      case WalkThroughTooltipPosition.LeftBottom:
        position.top = `${this.rect.top}px`;
        break;
    }

    return position;
  }

  next() {
    this.walkTroughService.nextStep();
  }

  stop(complete: boolean = false) {
    this.walkTroughService.stopIntro(complete);
  }
}
